import React, {useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {otpTitles, lobbyTabsEnum} from '../cellcomAbroadVariables';
import OtpHeadlineComponent from './OtpHeadlineWrapperComponent';

import {changePhoneInputHandler, onBlurHandler} from '../cellcomAbroadBlockSlice';

import TextInput from '../../../Shared/TextInput/TextInput';

const OtpVerifyPhoneComponent = (props) => {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      setImmediate(() => {
        ref.current?.focus();
      });
    }
  }, []);

  const headlineDescription = () => {
    if (props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT && !props.data.otpData.step1Ticket) {
      return otpTitles.business.description;
    } else if (props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS && !props.data.otpData.step1Ticket) {
      return otpTitles.packageExists.description;
    }
    return '';
  };

  return (
    <Container
      className={`otp-verification-bordered-container ${
        isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'mb-70' : ''
      }`}>
      <div className={isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? '' : 'd-flex'}>
        <Col className={isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-5'}>
          <OtpHeadlineComponent
            businessOtp={props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT}
            isPortrait={props.data.isPortrait}
            isSmallResolution={props.data.isSmallResolution}
            title={props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT ? otpTitles.business.title : otpTitles.packageExists.title}
            description={headlineDescription()}
          />
        </Col>
        <Col className={isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-7'}>
          <div className='otp-verify-phone'>
            <Col className={isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12 p-0' : ''}>
              <TextInput
                ref={ref}
                className='otp-phone-input'
                name='phone'
                type='tel'
                pattern='[0-9]*'
                id='phone'
                maxLength='10'
                autoComplete='off'
                placeholder={props.placeholder ?? 'טלפון'}
                required='required'
                value={props.data.otpPhoneForm.phone}
                error={props.data.otpPhoneForm.errors.phone}
                onBlur={(e) => props.onBlurHandler({target: e.target, form: props.data.otpPhoneForm, formName: 'otpPhoneForm'})}
                onChange={(e) => props.changePhoneInputHandler({target: e.target, form: props.data.otpPhoneForm})}
              />
            </Col>
          </div>
        </Col>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
  changePhoneInputHandler,
  onBlurHandler,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyPhoneComponent);
